import React, { useState } from "react";
import {
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Badge,
} from "reactstrap";
import DeleteModal from "components/Common/DeleteModal";
import { useSelector } from "react-redux";
import AssignSalesRepModal from "../AssignSalesRep";

const CardItem = (props) => {
	const {
		index,
		item,
		id,
		setStatusModal,
		setEditResale,
		Service,
		name,
		status,
		setShouldGetData,
		updateHandler,
		viewHandler,
	} = props;
	const boolStatus = status === "Live" ? true : false;
	const [salesRepModal, setSalesRepModal] = useState(false);
	const [deleteModal, setDeleteModal] = useState(false);
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const AuthData = useSelector((state) => state.Auth);
	const isExist = (data) =>
		AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com";

	const service = new Service();
	const toggle = () => setDropdownOpen((prevState) => !prevState);

	const handleCloseModal = (action, response) => {
		setDeleteModal(false);
		if (action === "delete") {
			setShouldGetData(true);
		}
	};
	const getColor = () => {
		return item.status === "Live"
			? "#0bf49b"
			: item.status === "Pending"
			? "#ff803d"
			: item.status === "Sold"
			? "#f7d708"
			: "red";
	};
	const getBackGround = () => {
		return item.status === "Live"
			? "#cef3e5"
			: item.status === "Pending"
			? "#f7d0bb"
			: item.status === "Sold"
			? "#f9f2c8"
			: "rgba(255,0,0,.3)";
	};
	return (
		<>
			<tr key={index}>
				<td className="font-size-13">{id}</td>
				<th className="font-size-14">{item.client?.split("/")[0]}</th>
				<th className="font-size-14">{item.unit_type}</th>
				<th className="font-size-14">{item.bedrooms}</th>
				<th className="font-size-14">{item.floor}</th>
				<th className="font-size-14">{item.area.name}</th>
				<th className="font-size-14">
					{!!item.compound?.name ? item.compound?.name : "_"}
				</th>
				<th className="font-size-14">
					{!!item?.sales_rep?.name?.en ? item?.sales_rep?.name?.en : "-"}
				</th>
				<th className="font-size-14">{item?.updated_at}</th>
				<th className="font-size-14">
					<Badge
						className={"font-size-14 p-2 m-0"}
						style={{ color: getColor(), background: getBackGround() }}>
						{item.status}
					</Badge>
				</th>
				{/* <td className='font-size-13'>
                    <AvForm>
                        <div className='form-check form-switch form-switch-md mb-1'>
                            <input
                                name='status'
                                checked={itemStatus}
                                type='checkbox'
                                className='form-check-input'
                                id='has_status'
                                onChange={changeStatus}
                            />
                        </div>
                    </AvForm>
                </td> */}
				{/* <td className='font-size-16'>{status ? "true" : "false"}</td> */}
				<td className="removebtnhover">
					<Dropdown
						className="dropdownWidth"
						color="light"
						isOpen={dropdownOpen}
						toggle={toggle}>
						<DropdownToggle caret>
							<i className="fa fa-ellipsis-v text-dark fa-lg"></i>
						</DropdownToggle>
						<DropdownMenu>
							{/* <DropdownItem tag={Link} to={`${adminPrefix}` + '/profile'}>View</DropdownItem> */}
							<DropdownItem onClick={viewHandler}>View</DropdownItem>

							{isExist("resale.edit") ? (
								<DropdownItem onClick={updateHandler}>Edit</DropdownItem>
							) : null}
							{isExist("resale.edit") ? (
								<DropdownItem
									onClick={() => {
										setEditResale();
										setStatusModal(true);
									}}>
									Change status
								</DropdownItem>
							) : null}
							{isExist("resale.edit") && (
								<DropdownItem onClick={() => setSalesRepModal((c) => !c)}>
									{item?.sales_rep?.id ? "Reassign" : "Assign"} Sales Rep
								</DropdownItem>
							)}
							{isExist("resale.delete") ? (
								<DropdownItem
									className="text-danger"
									onClick={() => {
										setDeleteModal(!deleteModal);
									}}>
									Remove Resale
								</DropdownItem>
							) : null}
						</DropdownMenu>
					</Dropdown>
				</td>
			</tr>
			<DeleteModal
				open={deleteModal}
				titleMsg={item?.client?.split("/")[0]}
				deletedItem={item}
				modelService={service}
				onCloseModal={(action) => handleCloseModal(action)}
			/>
			{salesRepModal ? (
				<AssignSalesRepModal
					modal={salesRepModal}
					toggle={() => setSalesRepModal((c) => !c)}
					resale_id={item.id}
					sales_rep={item.sales_rep}
					setShouldGetData={setShouldGetData}
				/>
			) : null}
		</>
	);
};

export default CardItem;
